import {
  buildFetchUser,
  fetchUserUsecase as _fetchUserUsecase,
} from "./fetch-user";
import { buildChangePassword, changePasswordUsecase as _changePasswordUsecase } from "./changePassword";
import {
  buildUser,
  addUserUseCase as _addUserUseCase,
} from "./add-user";
import {
  buildFetchUsers,
  fetchUsersUsecase as _fetchUsersUsecase,
} from "./fetch-users";
import {
  buildFetchUserById,
  fetchUserByIdUsecase as _fetchUserByIdUsecase,
} from "./fetchUserById";
import {
  buildUpdateUser,
  updateUserUsecase as _updateUserUsecase,
} from "./updateUser";
import {
  buildSearchUsers,
  searchUsersUsecase as _searchUsersUsecase,
} from "./search-user";
import {
  buildFetchTotalUsers,
  fetchTotalUsersUsecase as _fetchTotalUsersUsecase,
} from './fetch-total-users';


import UserRepository from "../../ports/userRepository";

// eslint-disable-next-line import/no-anonymous-default-export
export default (dependencies: {
  userRepo: UserRepository;
}): {
  fetchUser: _fetchUserUsecase;
  changePassword: _changePasswordUsecase;
  addUser: _addUserUseCase;
  fetchUsers: _fetchUsersUsecase;
  fetchTotalUsers: _fetchTotalUsersUsecase;
  fetchUserById: _fetchUserByIdUsecase;
  updateUser: _updateUserUsecase;
  searchUsers: _searchUsersUsecase;
} => {
  const { userRepo } = dependencies;

  const fetchUser = buildFetchUser({ userRepo });
  const changePassword = buildChangePassword({ userRepo });
  const addUser = buildUser({ userRepo });
  const fetchUsers = buildFetchUsers({ userRepo });
  const fetchUserById = buildFetchUserById({ userRepo });
  const updateUser = buildUpdateUser({ userRepo });
  const searchUsers = buildSearchUsers({ userRepo });
  const fetchTotalUsers = buildFetchTotalUsers({ userRepo });

  return { fetchUser, changePassword, fetchUsers, fetchUserById, updateUser, addUser, searchUsers, fetchTotalUsers };
};

export type fetchUserUsecase = _fetchUserUsecase;
export type changePasswordUsecase = _changePasswordUsecase;
export type addUserUsecase = _addUserUseCase;
export type fetchUsersUsecase = _fetchUsersUsecase;
export type fetchUserByIdUsecase = _fetchUserByIdUsecase;
export type updateUserUseCase = _updateUserUsecase;
export type searchUsersUsecase = _searchUsersUsecase;
export type fetchTotalUsersUsecase = _fetchTotalUsersUsecase;
